module.exports = __webpack_public_path__ + "img/6.3b502f41.png";